import {SearchFieldsStore} from 'stores/SearchStore';

export default SearchFieldsStore;
